
import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

interface AccordionProps {
  title: ReactNode;
  children: ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const AccordionComponent: React.FC<AccordionProps> = ({ title, children, isOpen, onToggle }) => {

  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-md mb-2 ${isOpen ? 'bg-gray-50 dark:bg-gray-700' : ''}`}>
      <button
        onClick={onToggle}
        className="w-full flex justify-between items-center py-4 px-6 text-left text-gray-800 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none rounded-t-lg"
      >
        <div className="flex-grow font-semibold">{title}</div>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`w-4 h-4 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`}
        />
      </button>
      <div
        className={`transition-all duration-500 ease-in-out ${
          isOpen ? 'max-h-screen opacity-100 overflow-y-auto' : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        <div className="p-6 border-t border-gray-200 dark:border-gray-700">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionComponent;
